import { ButtonInputWithPopover } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { TodoItemStatusFilter } from "../../../../clients/graphqlTypes.js";

export function TasksStatusFilterButton({
  value,
  setValue,
}: {
  value: Array<TodoItemStatusFilter> | undefined;
  setValue: (newValue: Array<TodoItemStatusFilter> | undefined) => void;
}) {
  const { t } = useTranslate(["Global"]);

  const isOpenChecked = value?.includes("OPEN") ?? false;
  const isCompletedChecked = value?.includes("DONE") ?? false;
  const counter =
    isOpenChecked && !isCompletedChecked
      ? 1
      : !isOpenChecked && isCompletedChecked
        ? 1
        : undefined;

  return (
    <ButtonInputWithPopover
      label={t("Status", { ns: "Global" })}
      counter={counter}
      content={<TasksStatusFilterForm value={value} setValue={setValue} />}
      popoverWidth="md"
    />
  );
}

function TasksStatusFilterForm({
  value,
  setValue,
}: {
  value: Array<TodoItemStatusFilter> | undefined;
  setValue: (newValue: Array<TodoItemStatusFilter> | undefined) => void;
}) {
  const { t } = useTranslate(["Global"]);

  const isOpenChecked = value?.includes("OPEN") ?? false;
  const isCompletedChecked = value?.includes("DONE") ?? false;

  return (
    <Box
      sx={{
        p: 1,
      }}
    >
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                size="medium"
                checked={isOpenChecked}
                onChange={(_event, checked) => {
                  if (checked) {
                    setValue(Array.from(new Set([...(value ?? []), "OPEN"])));
                  } else {
                    const newValue = value?.filter(s => s !== "OPEN");
                    setValue(newValue?.length ? newValue : undefined);
                  }
                }}
              />
            }
            label={
              <Typography variant="body1">
                {t("Open", { ns: "Global" })}
              </Typography>
            }
            sx={{ ml: 0, mr: 0 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                size="medium"
                checked={isCompletedChecked}
                onChange={(_event, checked) => {
                  if (checked) {
                    setValue(Array.from(new Set([...(value ?? []), "DONE"])));
                  } else {
                    setValue(value?.filter(s => s !== "DONE") ?? undefined);
                  }
                }}
              />
            }
            label={
              <Typography variant="body1">
                {t("Completed", { ns: "Global" })}
              </Typography>
            }
            sx={{ ml: 0, mr: 0 }}
          />
        </FormGroup>
      </FormControl>
    </Box>
  );
}
